import DuoFunnelLayout from '@/components/v2/DuoFunnelLayout'
import DuoMascot from '@/components/v2/DuoMascot'
import DuoSpeechBubble from '@/components/v2/DuoSpeechBubble'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import type { StepScreenProps } from './types'

/**
 * A Duolingo mascot beat: the bubble sits centred above the mascot, the top
 * chrome is gone and the only control is CONTINUE. The hidden field keeps the
 * tracked shape of the shared `ProgressPage`: name is the English title, value
 * is the English "Continue".
 */
export default function MascotStep({
  bodyKey,
  interpolation,
  step,
  titleKey,
  totalSteps,
}: StepScreenProps & {
  bodyKey?: string
  titleKey: string
}) {
  const { t } = useTranslation()

  return (
    <Form method="post">
      <DuoFunnelLayout
        footer={
          <button
            className="duo-button-primary"
            data-testid="button-continue"
            type="submit"
          >
            {t('shared.continue')}
          </button>
        }
        step={step}
        totalSteps={totalSteps}
        withProgress={false}
      >
        <input
          name={t(titleKey, { lng: 'en', ...interpolation })}
          type="hidden"
          value={t('shared.continue', { lng: 'en' })}
        />

        <div className="animate-fade-up flex grow flex-col items-center justify-center">
          <div className="w-full max-w-xs">
            <DuoSpeechBubble>
              <p className="text-duo-ink text-lg font-extrabold">
                {t(titleKey, interpolation)}
              </p>

              {bodyKey && (
                <p className="text-duo-muted mt-2 text-[15px] leading-relaxed">
                  {t(bodyKey, interpolation)}
                </p>
              )}
            </DuoSpeechBubble>
          </div>

          <DuoMascot className="mt-8 h-28 w-28" />
        </div>
      </DuoFunnelLayout>
    </Form>
  )
}
